import PropTypes from "prop-types";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Controller, useController } from "react-hook-form";

//---------------------------------------------------------------------------------
SelectField.propTypes = {
  control: PropTypes.object,
  style: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  errorMsg: PropTypes.string,
  helperText: PropTypes.string,
  multiline: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  itemArray: PropTypes.array,
  required: PropTypes.bool,
  multiple: PropTypes.bool,
};

SelectField.defaultProps = {
  style: { minWidth: 120 },
  multiple: false,
};
//---------------------------------------------------------------------------------

export default function SelectField({
  control,
  style,
  name,
  label,
  errorMsg,
  fullWidth,
  disabled,
  helperText,
  itemArray,
  required,
  multiple,
}) {
  const {
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: {
      validate: (value) => {
        if (!required) return true;
        if (multiple) {
          return Array.isArray(value) && value.length > 0 ? true : errorMsg;
        }
        return value ? true : errorMsg;
      },
    },
  });

  const valueLabelMap = itemArray?.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
  }, {}) ?? {};

  const renderSelectedValue = (selected) => {
    if (!Array.isArray(selected)) return valueLabelMap[selected] || selected || "";
    return selected
      .map((val) => valueLabelMap[val] || val)
      .filter(Boolean)
      .join(", ");
  };

  return (
    <FormControl style={style} error={error}>
      <InputLabel id={`${name}-select-field-label`}>
        {required ? label + "*" : label}
      </InputLabel>
      <Controller
        render={({ field }) => (
          <Select
            id={`${name}-select-field`}
            label={label}
            {...field}
            disabled={disabled}
            multiple={multiple}
            renderValue={multiple ? renderSelectedValue : undefined}
            value={field.value ?? (multiple ? [] : "")}
            required={required}
          >
            {itemArray.map((item) => (
              <MenuItem key={item.value + "-key"} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        )}
        control={control}
        name={name}
        fullWidth={fullWidth}
      />
      {error && <FormHelperText>{errorMsg}</FormHelperText>}
      {helperText && !error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
